<script setup lang="ts">
import { computed, toRef } from 'vue';
import Tr from '@/i18n/translation';
import { useStateStore } from '@/stores/state.store';

const stateStore = useStateStore();

const props = defineProps({
  sendText: {
    type: String,
    required: true,
  },
});

const mainColor = toRef(() => stateStore.getColors.mainColor);
const buttonColor = toRef(() => stateStore.getColors.buttonColor);
const backgroundColor = toRef(() => stateStore.getColors.backgroundColor);

const btnText = computed(() => {
  return props.sendText;
});

const btnColor = computed(() => {
  return buttonColor.value ? buttonColor.value : mainColor.value;
});
</script>

<template>
  <div class="sender">
    <div class="send">
      <component
        :is="stateStore.isAllButtonsDisabled ? 'span' : 'router-link'"
        class="button btn-bold"
        :to="Tr.i18nRoute({ name: 'Sender' })"
        ><b>{{ btnText }}</b></component
      >
    </div>
  </div>
</template>

<style lang="scss">
/* stylelint-disable selector-class-pattern */
.q-field__input,
.q-file__filler,
.q-field__label,
.q-field--outlined,
.q-field__control,
.q-field__control::after {
  color: v-bind(mainColor);
}
/* stylelint-enable selector-class-pattern */
</style>

<style lang="scss" scoped>
.sender {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  margin: auto;
  align-items: stretch;
  text-transform: uppercase;
  letter-spacing: 2px;

  .send {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }

  .sender-text {
    font-size: 16px;
    border-bottom: 1px solid v-bind(btnColor);
    text-align: left;
    padding-bottom: 10px;
    white-space: nowrap;
    display: flex;
    align-items: end;
    flex-basis: auto;
  }

  .button {
    border-radius: 48.707px;
    border: 2px solid v-bind(btnColor);
    color: v-bind(backgroundColor);
    background-color: v-bind(btnColor);
    padding: 15px 25px;
    font-size: 25px;
    white-space: nowrap;
    text-align: center;
    transition: background-color 1s ease;
    cursor: pointer;

    &:hover {
      background-color: v-bind(backgroundColor);
      color: v-bind(btnColor);
    }

    @media screen and (max-width: 500px) {
      font-size: 18px;
      line-height: 30px;
      padding: 10px 20px;
    }
  }

  .btn-bold {
    border: 3px solid v-bind(btnColor);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-wrap: wrap;
  }
}
</style>
